import { Box } from '@mui/material'

import { useAppDispatch, useAppSelector } from 'store/hooks'
import { fetchUserData } from 'store/userSlice'
import { TypographyHeaderExtra } from 'ui/typography/TypographyHeaderExtra'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import FarmFillCard from './shared/FarmFillCard'

const FillPage = () => {
	const dispatch = useAppDispatch()
	const { userData, userDataPending } = useAppSelector(
		state => state.userReducer,
	)
	if (!userData.id) {
		dispatch(fetchUserData())
	}
	return (
		<Box sx={{ pt: '24px', pr: '150px' }}>
			{userDataPending ? (
				<h1>Загрузка...</h1>
			) : (
				<>
					<Box>
						<TypographyHeaderExtra>{`${
							userData.firstname + ' ' + userData.lastname
						}, добро пожаловать!`}</TypographyHeaderExtra>
						<TypographyPrimary sx={{ pt: '24px' }}>
							Выберите ферму для первичного заполнения данных по рационам,
							группам и плану кормления.
						</TypographyPrimary>
					</Box>
					<FarmFillCard
						title={userData.company.title}
						id={userData.company.id}
					/>
				</>
			)}
		</Box>
	)
}

export default FillPage
